module.exports = __webpack_public_path__ + "static/media/Hello-2.16e56d81.png";